import type { IconProps } from '@/shared/ui/icons/types';

export const FlagUzIcon = (props: IconProps) => (
  <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="20" fill="#fff" />
    <rect width="28" height="6.4" fill="#0099b5" />
    <rect y="13.6" width="28" height="6.4" fill="#1eb53a" />
    <rect y="6.1" width="28" height="0.6" fill="#ce1126" />
    <rect y="13.3" width="28" height="0.6" fill="#ce1126" />
    <path
      d="M5.4 2.1a2.2 2.2 0 1 0 0 4.2 1.7 1.7 0 1 1 0-4.2Z"
      fill="#fff"
    />
    <g fill="#fff">
      <circle cx="8.1" cy="2.6" r="0.35" />
      <circle cx="9.4" cy="2.6" r="0.35" />
      <circle cx="8.1" cy="3.8" r="0.35" />
      <circle cx="9.4" cy="3.8" r="0.35" />
      <circle cx="10.7" cy="3.8" r="0.35" />
      <circle cx="9.4" cy="5" r="0.35" />
      <circle cx="10.7" cy="5" r="0.35" />
      <circle cx="12" cy="5" r="0.35" />
    </g>
  </svg>
);
